const profile = {
    title: 'プロフィール',
    userInfo: 'ユーザー情報',
    name: '名前',
    email: 'メールアドレス',
    role: 'ロール',
    tenant: 'テナント',
    groups: 'グループ',
    security: 'セキュリティ',
    mfa: '多要素認証 (MFA)',
    mfaEnabled: '有効',
    mfaDisabled: '無効',
    lastVerified: '最終認証日時',
    backupCodesRemaining: 'バックアップコード残数',
    manageMfa: 'MFA設定管理',
    enableMfa: 'MFAを有効化',
    mfaNotAvailable: 'MFA情報を取得できませんでした',
    activeSessions: 'アクティブセッション',
    noActiveSessions: 'アクティブなセッションがありません',
    trustedDevices: '信頼済みデバイス',
    noTrustedDevices: '信頼済みデバイスがありません',
    manageInSettings: '設定で管理',
    unknownBrowser: '不明なブラウザ',
    unnamedDevice: '名前のないデバイス',
    sessionDeleted: 'セッションを削除しました',
    deviceRemoved: '信頼済みデバイスを削除しました',
    failedToDelete: 'セッションの削除に失敗しました',
    failedToRemove: '信頼済みデバイスの削除に失敗しました',
    failedToLoadProfile: 'プロフィールデータの読み込みに失敗しました',
    deleteSession: 'セッションを削除',
    removeTrustedDevice: '信頼済みデバイスを削除',
  };

export default profile;
